<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  canPermanentDelete: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  'edit',
  'delete',
  'hardDelete',
  'reprocess',
  'pause',
  'resume',
  'refresh',
]);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleHardDelete = campaign => emit('hardDelete', campaign);
const handleReprocess = campaign => emit('reprocess', campaign);
const handlePause = campaign => emit('pause', campaign);
const handleResume = campaign => emit('resume', campaign);
const handleRefresh = campaign => emit('refresh', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :created-at="campaign.created_at"
      :delivery-report="campaign.delivery_report"
      :is-live-chat-type="isLiveChatType"
      :can-permanent-delete="canPermanentDelete"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @hard-delete="handleHardDelete(campaign)"
      @reprocess="handleReprocess(campaign)"
      @pause="handlePause(campaign)"
      @resume="handleResume(campaign)"
      @refresh="handleRefresh(campaign)"
    />
  </div>
</template>
